export default {"src":"/_next/static/media/loadingOwl.baf21a80.gif","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};